<template>
  <div class="container_box">
    <div class="content pt-15">
      <!-- 内容 -->
      <div class="bold9 size20 color1 mb-20">
        项目名称：{{ fenBaoData.title }}
      </div>
      <div class="flex between">
        <!-- 竞价信息 -->
        <div>
          <div class="box">
            <div>
              <span
                style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                "
                >项目信息</span
              >
              <div class="textBox flex flex-column around">
                <span>场次号：{{ fenBaoData.sessionNum }}</span>
                <span
                  >报价方式：{{
                    fenBaoData.payMode == 1 ? "一次性付清" : "阶段性付款"
                  }}</span
                >
                <span>竞价开始时间：{{ fenBaoData.beginTime }}</span>
                <span>本次竞价时间：2小时</span>
              </div>
            </div>
            <div class="center-border"></div>

            <div>
              <span
                style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                "
                >连续报价规则</span
              >
              <div class="textBox flex flex-column around">
                <span>准备时间：60秒</span>
                <span>应价时间:90秒</span>
                <span>加速应价时间：30秒</span>
              </div>
            </div>
          </div>
          <div class="loginBox">
            <div>
              <span
                style="
                  font-size: 14px;
                  color: #3b426b;
                  font-weight: bold;
                  margin-bottom: 8px;
                "
                >连续报价规则</span
              >
              <div class="textBox textBox-border flex flex-column around">
                <span>公司名称：{{ fenBaoData.publishCompany }}</span>
                <span>报价号码：5号</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 竞价须知 -->
        <div class="Box">
          <!-- 表格 -->
          <div class="tableBox">
            <div
              style="
                font-size: 14px;
                font-weight: bold;
                color: #3b426b;
                margin-bottom: 14px;
              "
            >
              报价记录
            </div>
            <!-- 表格 -->
            <el-table
              :header-cell-style="{
                background: '#3B426C',
                color: '#ffffff',
                padding: '0px',
                height: '40px',
              }"
              :cell-style="{ padding: '0px' }"
              :row-style="{ height: '40px' }"
              class="mb-10"
              :data="tableData"
              stripe
              style="
                font-size: 14px;
                border-radius: 20px 20px 0 0;
                border: 1px solid #3b426b;
              "
            >
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="100px"
              >
                <template></template>
              </el-table-column>
              <el-table-column prop="lie2" label="分包" align="center">
              </el-table-column>
              <el-table-column prop="lie3" label="报价人" align="center">
              </el-table-column>
              <el-table-column prop="lie4" label="报价金额" align="center">
              </el-table-column>
              <el-table-column prop="lie5" label="报价时间" align="center">
              </el-table-column>
            </el-table>
          </div>
          <!-- 分包 -->
          <div class="flex between items-center">
            <div class="fenbaoBox" v-for="(item, i) in fenBaoList" :key="i">
              <div :class="item.isDialog ? 'fenbaoBox-active' : ''">
                <div class="topText flex between">
                  <div class="leftText">{{ item.name }}</div>
                  <div class="rightText flex flex-column around">
                    <span>最高限价：{{ item.maxPrice }}元</span>
                    <span>每次报价不低于：{{ item.minPrice }}元</span>
                    <span @click="closeSearch(item, i)"
                      >产品明细：{{ item.isStatus == false ? "展开" : "收起" }}
                      <i
                        :class="
                          item.isStatus
                            ? 'iconfont icon-shangjiantou_huaban'
                            : 'iconfont icon-xiajiantou_huaban'
                        "
                      ></i>
                      <!-- 表格 -->
                      <el-table
                        v-if="item.isStatus"
                        :header-cell-style="{
                          background: '#3B426C',
                          color: '#ffffff',
                          padding: '0px',
                          height: '40px',
                        }"
                        :cell-style="{ padding: '0px' }"
                        :row-style="{ height: '40px' }"
                        id="tableBox"
                        class="dialog mb-10"
                        :data="cpmxTable"
                        stripe
                      >
                        <el-table-column
                          prop="lie1"
                          label="产品名称"
                          align="center"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="lie2"
                          label="产品型号"
                          align="center"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="lie3"
                          label="供应量"
                          align="center"
                        >
                        </el-table-column>
                      </el-table>
                    </span>
                  </div>
                </div>
                <div class="bottomBox flex flex-column around">
                  <span>当前最低价：{{ item.currentPrice }}元</span>
                  <span>最低报价人：{{ item.userName }}</span>
                  <span style="font-weight: bold"
                    >应价时间：<span style="font-size: 36px; color: #ff0053">{{
                      item.date
                    }}</span
                    >秒</span
                  >
                  <el-input
                    v-model="item.price"
                    placeholder="请输入金额"
                    oninput="value=value.replace(/[^\d.]/g,'')"
                  ></el-input>
                  <div class="btn" @click="baoJia(item, i)">报价</div>
                </div>
              </div>

              <!-- 价格弹窗 -->
              <div
                v-if="item.isDialog"
                class="price-box flex flex-center items-center"
              >
                <div class="dialog-box">
                  <div class="title">请确认报价金额</div>
                  <div class="mt-15 money size14 bold">{{ item.price }}元</div>
                  <div class="btn-box flex around mt-15 pl-15 pr-15">
                    <div
                      class="pointer yes size14 bold"
                      @click="moneyYes(item, i)"
                    >
                      确定
                    </div>
                    <div
                      @click="moneyNo(item, i)"
                      class="pointer yes no-yes size14 bold"
                    >
                      取消
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //是否展开
      showAll: false,

      //表格数据
      tableData: [],
      cpmxTable: [],
      //分包列表
      fenBaoList: [],
      bid: null,
      fenBaoData: {},
      jiLuList: [],
    };
  },
  created() {
    this.bid = this.$route.query.id;
  },
  mounted() {
    this.getFenBaoData();
    this.getBaoJiaJiLu();
  },
  methods: {
    //获取报价记录
    async getBaoJiaJiLu() {
      const { data: res } = await this.$axios.get(
        "/api/biddingInfo/getQuoteRecord",
        {
          params: {
            biddingId: this.bid,
            supplierId: window.sessionStorage.getItem("supplierId"),
          },
          headers: {
            token: window.sessionStorage.getItem("token"),
          },
        }
      );
      console.log(res);
      if (res.code == 200) {
        this.jiLuList = res.data;
      } else {
        this.$message.closeAll();
        return this.$message.error(res.msg);
      }
    },
    //获取分包详情
    async getFenBaoData() {
      const { data: res } = await this.$axios.get(
        "/api/biddingInfo/getBiddingDetail",
        {
          params: {
            biddingId: this.bid,
          },
        }
      );
      console.log(res);
      if (res.code == 200) {
        this.fenBaoData = res.data;
      } else {
        this.$message.closeAll();
        return this.$message.error(res.msg);
      }
    },
    closeSearch(item, i) {
      item.isStatus = !item.isStatus;
      this.fenBaoList.splice(i, 1, item);
    },
    //点击报价
    baoJia(item, i) {
      if (!item.price) {
        this.$message.closeAll();
        return this.$message.error("请输入价格");
      }
      item.isDialog = !item.isDialog;
      this.fenBaoList.splice(i, 1, item);
    },
    //报价确定按钮
    moneyYes(item, i) {
      item.isDialog = !item.isDialog;
      this.fenBaoList.splice(i, 1, item);
      item.price = null;
    },
    moneyNo(item, i) {
      item.price = null;
      item.isDialog = !item.isDialog;
      this.fenBaoList.splice(i, 1, item);
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}

//隔行变色的背景色
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f3f6fb !important;
}
//表头内边距
/deep/.el-table__header tr.el-table__header th {
  padding: 0 !important;
}
//表格内边距
/deep/.el-table__body tr.el-table__body td {
  padding: 0 !important;
}
//表头单元格右边框
/deep/.el-table th.el-table__cell > .cell {
  border-right: 1px solid #fff;
}
//取消表头单元格最后一列右边框
/deep/.el-table th.el-table__cell:nth-child(5) > .cell {
  border-right: none;
}
//最后一列不要右边框
/deep/.el-table__cell:last-of-type > .cell {
  border-right: none;
}
//明细表格表头最后一列不要右边框
/deep/.dialog.el-table th.el-table__cell:nth-child(3) > .cell {
  border-right: none;
}
//表格单元格右边框
/deep/.el-table .cell {
  border-right: 1px solid #95b3db;
}
//表格下边框
/deep/.el-table td.el-table__cell {
  border-bottom: none;
}
//报价金额输入框
/deep/.el-input__inner {
  width: 120px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid #ccd9e9;
  &::placeholder {
    text-align: center;
    font-size: 14px;
  }
}
//左边弹框
/deep/.left {
  position: absolute;
  top: 220px;
  left: 460px;
}
//中间弹框
/deep/.center {
  position: absolute;
  top: 220px;
  left: 750px;
}
//右侧弹框
/deep/.right {
  position: absolute;
  top: 220px;
  left: 1040px;
}
//弹框标题
/deep/.el-dialog__title {
  color: #1c65c4;
  font-size: 14px;
}
//弹框头部
/deep/.el-dialog__header {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #ccd9e9;
  line-height: 38px;
  padding: 0;
}
//弹框内容
/deep/.el-dialog__body {
  padding: 14px 0;
  color: #3b426b;
  font-size: 14px;
  text-align: center;
}
//弹框按钮
/deep/.el-button.el-button--primary {
  padding: 5px 16px;
  font-size: 14px;
  border-radius: 25px;
  background-color: #1c65c4;
  margin-right: 14px;
}
/deep/.el-button.el-button--default {
  padding: 5px 16px;
  font-size: 14px;
  border-radius: 25px;
  color: #fff;
  background-color: #ccd9e9;
  margin: 0;
}
//弹框底部
/deep/.el-dialog__footer {
  text-align: center;
  padding: 0;
  padding-bottom: 14px;
}
.Box {
  margin-left: 26px;
  //右侧表格
  .tableBox {
    padding: 20px 20px;
    box-sizing: border-box;
    width: 872px;
    height: 364px;
    border-right: 4px solid #95b3db;
    background-color: #fff;
    margin-bottom: 27px;
  }
  .fenbaoBox-active {
    filter: blur(2px);
  }
  .fenbaoBox {
    position: relative;
    width: 280px;
    height: 411px;
    border-radius: 20px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 35px 15px;
    .price-box {
      width: 280px;
      height: 411px;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(28, 101, 196, 0.05);
      border-radius: 20px;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.6);
      filter: none;
      .dialog-box {
        width: 180px;
        height: 130px;
        background: #fff;
        .title {
          text-align: center;
          height: 38px;
          line-height: 38px;
          color: #1c65c4;
          font-size: 14px;
          font-weight: bold;
          border-bottom: 1px solid #ccd9e9;
        }
        .money {
          color: #3b426b;
          text-align: center;
        }
        .btn-box {
          .yes {
            width: 60px;
            height: 30px;
            background: #1c65c4;
            text-align: center;
            line-height: 30px;
            color: #fff;
            border-radius: 25px;
            box-sizing: border-box;
          }
          .no-yes {
            background: #ccd9e9;
          }
        }
      }
    }

    .topText {
      border-bottom: 1px solid #ccd9e9;
      box-sizing: border-box;
      padding-bottom: 24px;
      .leftText {
        height: 77px;
        box-sizing: border-box;
        padding-right: 14px;
        border-right: 1px solid #1c65c4;
        font-size: 18px;
        line-height: 77px;
        color: #1c65c4;
        margin-right: 17px;
        font-weight: bold;
      }
      .rightText {
        span {
          color: #3b426b;
          font-size: 14px;
          .iconfont {
            color: #1c65c4;
            font-size: 16px !important;
          }
          #tableBox {
            width: 258px;
            height: 274px;
            font-size: 14px;
            border-radius: 10px;
            border: 1px solid #1c65c4;
            position: absolute;
            top: 120px;
            left: 11px;
            // display: none;
            z-index: 1 !important;
          }
        }
      }
    }
    .bottomBox {
      height: 274px;
      box-sizing: border-box;
      padding: 29px 50px;
      text-align: center;
      span {
        color: #3b426b;
        font-size: 14px;
      }
      .btn {
        width: 80px;
        height: 30px;
        margin-left: 40px;
        text-align: center;
        line-height: 30px;
        background-color: #1c65c4;
        color: #fff;
        border-radius: 25px;
        cursor: pointer;
      }
    }
  }
}
//左侧信息
.box {
  width: 298px;
  height: 518px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.loginBox {
  width: 294px;
  height: 259px;
  background-color: #fff;
  padding: 35px 22px 44px 20px;
  box-sizing: border-box;
}
.textBox {
  width: 252px;
  border-radius: 13px;
  margin-top: 8px;
  margin-bottom: 30px;
  box-sizing: border-box;
  padding: 50px 10px;
  color: #565c7f;
  font-size: 14px;
}
.textBox-border {
  border: 1px solid #95b3db;
}
.center-border {
  width: 252px;
  border: 1px solid #95b3db;
  height: 0;
  margin-bottom: 40px;
}
</style>